import qs from 'qs';

export default params => qs.stringify(params, {arrayFormat: 'bracket', encode: false, skipNulls: true});


// WEBPACK FOOTER //
// ./src/functions/queryString.js